module.exports = __webpack_public_path__ + "assets/img/a3e56cbe594ff52315f01ad971527635.png";